/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export enum WizardSubStepTitlesEnum {
    GENERAL = 'general',
    FLOATING_IPS = 'floating_ip',
    HEADERS = 'headers',
    SSL = 'ssl',
    CERTIFICATES = 'certificates',
    HTTP_CONNECTIONS = 'http_connection',
    CLIENT_CONNECTIONS = 'client_connections',
    HEALTH = 'health',
    CONNECTION_OPTIONS = 'connection_options',
    LAYER_7_ADVANCED = 'layer_7_advanced',
    DOMAIN_NAME = 'domain_name',
    HEALTHCHECK = 'healthcheck',
    REGIONS = 'regions',
    FALLBACK = 'fallback',
    PERSISTENCE = 'persistence',
    FEEDBACK = 'feedback',
    RIP_IDS = 'real_servers',
}
